module.exports = "//public.zight.com/packs/media/images/file-placeholder-2c41c8960b22598857d3c26780fddec3.svg";